var _excluded = ["inverse", "logoLink", "isTestEnvironment", "items", "className", "language", "availableLanguages", "onLanguageChange", "locale", "availableLocales", "onLocaleChange", "activePath", "buttonItemsForNav", "commonItemsForNav", "buttonItems", "submenuItems", "navType", "isPillNavigation", "businessTabLink", "personalTabLink", "cta", "isCTAshown", "isScrolling", "isModern", "withCountrySelector"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React, { useState, useEffect } from 'react';
import Types from 'prop-types';
import classNames from 'classnames';
import Header from './Header';
import Menu from './Menu';
import NavTypes from '../../NavTypes';
import { LocaleValues } from '../../common/l10n';
var Navigation = function Navigation(_ref) {
  var inverse = _ref.inverse,
    logoLink = _ref.logoLink,
    isTestEnvironment = _ref.isTestEnvironment,
    items = _ref.items,
    className = _ref.className,
    language = _ref.language,
    availableLanguages = _ref.availableLanguages,
    onLanguageChange = _ref.onLanguageChange,
    locale = _ref.locale,
    availableLocales = _ref.availableLocales,
    onLocaleChange = _ref.onLocaleChange,
    activePath = _ref.activePath,
    buttonItemsForNav = _ref.buttonItemsForNav,
    commonItemsForNav = _ref.commonItemsForNav,
    buttonItems = _ref.buttonItems,
    submenuItems = _ref.submenuItems,
    navType = _ref.navType,
    isPillNavigation = _ref.isPillNavigation,
    businessTabLink = _ref.businessTabLink,
    personalTabLink = _ref.personalTabLink,
    cta = _ref.cta,
    isCTAshown = _ref.isCTAshown,
    isScrolling = _ref.isScrolling,
    isModern = _ref.isModern,
    withCountrySelector = _ref.withCountrySelector,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isMenuOpen = _useState2[0],
    setIsMenuOpen = _useState2[1];
  var toggleMenu = function toggleMenu() {
    var newIsMenuOpen = !isMenuOpen;
    if (newIsMenuOpen) {
      addNoScroll();
    } else {
      removeNoScroll();
    }
    setIsMenuOpen(newIsMenuOpen);
  };
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isMobileViewport = _useState4[0],
    setIsMobileViewport = _useState4[1];
  useEffect(function () {
    var mobileViewportQuery = window.matchMedia('(max-width: 991px)');
    var handleViewportChange = function handleViewportChange(_ref2) {
      var matches = _ref2.matches;
      setIsMobileViewport(matches);
      if (!matches) {
        removeNoScroll();
        setIsMenuOpen(false);
      }
    };
    setIsMobileViewport(mobileViewportQuery.matches);
    mobileViewportQuery.addListener(handleViewportChange);
    return function () {
      mobileViewportQuery.removeListener(handleViewportChange);
    };
  }, []);
  return /*#__PURE__*/React.createElement("header", _extends({
    className: classNames('tw-public-nav', "tw-public-nav--".concat(language), {
      'np-theme-navy': !isModern && inverse,
      'is-open': isMenuOpen,
      'tw-public-nav--submenu': submenuItems.length,
      'is-cta-shown': isCTAshown && isPillNavigation && !isMenuOpen,
      'is-scrolling': isScrolling && isPillNavigation && !isMenuOpen,
      'is-cta-hidden': !isCTAshown && isPillNavigation && !isMenuOpen,
      'is-not-scrolling': !isScrolling && isPillNavigation && !isMenuOpen,
      'np-theme-personal': isMenuOpen && isModern && isMobileViewport
    }, className)
  }, otherProps), /*#__PURE__*/React.createElement("div", {
    className: classNames('tw-public-nav__grid', {
      container: !isPillNavigation
    })
  }, /*#__PURE__*/React.createElement(Header, {
    isMenuOpen: isMenuOpen,
    onToggle: toggleMenu,
    inverse: inverse,
    logoLink: logoLink,
    isTestEnvironment: isTestEnvironment,
    buttonItems: buttonItems
  }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
    className: "icon-bar"
  }), /*#__PURE__*/React.createElement("span", {
    className: "icon-bar"
  }), /*#__PURE__*/React.createElement("span", {
    className: "icon-bar"
  }))), items.length + buttonItemsForNav.length + buttonItems.length + commonItemsForNav.length > 0 && /*#__PURE__*/React.createElement(Menu, {
    items: items,
    buttonItemsForNav: [].concat(_toConsumableArray(buttonItemsForNav), _toConsumableArray(buttonItems)),
    commonItemsForNav: _toConsumableArray(commonItemsForNav),
    isOpen: isMenuOpen,
    onToggle: toggleMenu,
    inverse: inverse,
    link: logoLink,
    language: language,
    availableLanguages: availableLanguages,
    onLanguageChange: onLanguageChange,
    locale: locale,
    availableLocales: availableLocales,
    onLocaleChange: onLocaleChange,
    activePath: activePath,
    submenuItems: submenuItems,
    navType: navType,
    isPillNavigation: isPillNavigation,
    businessTabLink: businessTabLink,
    personalTabLink: personalTabLink,
    cta: cta,
    isCTAshown: isCTAshown && cta,
    isScrolling: isScrolling,
    withCountrySelector: withCountrySelector
  })));
};
var addNoScroll = function addNoScroll() {
  document.documentElement.classList.add('nav-no-scroll');
  document.body.classList.add('nav-no-scroll');
};
var removeNoScroll = function removeNoScroll() {
  document.documentElement.classList.remove('nav-no-scroll');
  document.body.classList.remove('nav-no-scroll');
};
Navigation.defaultProps = {
  items: [],
  buttonItems: [],
  buttonItemsForNav: [],
  commonItemsForNav: [],
  inverse: true,
  logoLink: '/',
  isTestEnvironment: false,
  className: '',
  availableLanguages: undefined,
  onLanguageChange: undefined,
  locale: '',
  onLocaleChange: undefined,
  availableLocales: undefined,
  activePath: undefined,
  submenuItems: [],
  isPillNavigation: false,
  cta: undefined,
  isCTAshown: false,
  isScrolling: false,
  withCountrySelector: false
};
export default Navigation;